import { render, staticRenderFns } from "./ListRopa.vue?vue&type=template&id=72fbfc74&"
import script from "./ListRopa.vue?vue&type=script&lang=js&"
export * from "./ListRopa.vue?vue&type=script&lang=js&"
import style0 from "./ListRopa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports